export default "__VITE_ASSET__d36355dc__"